<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="派发管理">
        <span slot="label"><i class="iconfont icon-dispatch2" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_fo_dispatch")}}</span>
        <OrderForecastDispatchSearch></OrderForecastDispatchSearch>
      </el-tab-pane>
      <el-tab-pane label="查询(明细列表)">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_fo_detail")}}</span>
        <OrderForecastDispatchItems></OrderForecastDispatchItems>
      </el-tab-pane>
      <el-tab-pane label="查询(供应商)">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_fo_detail_vend")}}</span>
        <OrderForecastDispatchVendSearch></OrderForecastDispatchVendSearch>
      </el-tab-pane>
      <el-tab-pane label="新建">
        <span slot="label"><i class="iconfont icon-add-new" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_fo_create")}}</span>
        <OrderForecastDispatchAdd></OrderForecastDispatchAdd>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderForecastDispatchSearch from "./OrderForecastDispatchSearch";
import OrderForecastDispatchVendSearch from "./OrderForecastDispatchVendSearch";
import OrderForecastDispatchAdd from "./OrderForecastDispatchAdd";
import OrderForecastDispatchItems from "./OrderForecastDispatchItems";

export default {
  name: "saleOrderDispatch",
  components: {
    OrderForecastDispatchSearch,
    OrderForecastDispatchVendSearch,
    OrderForecastDispatchAdd,
    OrderForecastDispatchItems
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
